function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .imprimirIcon {\r\n        fill: currentColor;\r\n        stroke-width: 0px;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "imprimirIcon",
  d: "M24.1,10.9c0-1-1-1.8-2.3-1.8h-.5v-1.7c0-.7-.5-1.3-1.2-1.5v-1L15.1,0H4v5.9c-.7.1-1.2.8-1.2,1.5v1.7h-.5c-1.2,0-2.3.8-2.3,1.8v7c0,1.2,1,2.3,2.3,2.3h1.7v4h16.2v-4h1.7c1.2,0,2.3-1,2.3-2.3v-7ZM18.4,4.8h-3.3V1.6l3.3,3.2ZM14,1.5v4.4h4.7v3.2H5.5V1.5h8.5ZM18.7,22.6H5.5v-6.2h13.2v6.2ZM21.9,18.2h-1.7v-3.3H4v3.3h-1.7c-.2,0-.4-.2-.4-.4v-5.2h20.3v5.2c0,.2-.2.4-.4.4Z"
});

var SvgImprimir = function SvgImprimir(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24.1 24.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImprimir, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Imprimir.e85e743d.svg";
export { ForwardRef as ReactComponent };